import React from 'react';
import Tag from '../Tag';
import BackButton from '../BackButton';
import { theme } from '@/styles/theme';
import { PrivateIcon, PublicIcon } from '@/icons';
import { useTranslation } from 'react-i18next';
import { ApiDetailTab } from '@/types/app';
import { StyledIconContainer } from '../IconContainer';
import {
  StyledHeaderContainer,
  StyledContentContainer,
  StyledTopRowContainer,
  StyledLeftSideContainer,
  StyledApiTitle,
  StyledTagsContainer,
  StyledTabsContainer,
  StyledTabItem,
  StyledTabLabel,
} from './ApiHeader.styles';

interface ApiHeaderData {
  title: string;
  isPublic: boolean;
  tags: string[];
}

type ApiHeaderProps = {
  apiHeaderData: ApiHeaderData;
  activeTab: string;
  onTabChange: (tab: string) => void;
  onBackClick: () => void;
  tabs?: string[];
};

const ApiHeader: React.FC<ApiHeaderProps> = ({
  apiHeaderData,
  activeTab,
  onTabChange,
  onBackClick,
  tabs = [ApiDetailTab.FEATURES, ApiDetailTab.GUIDES, ApiDetailTab.SPECS],
}) => {
  const { t } = useTranslation();
  const tabLabels = tabs;

  return (
    <StyledHeaderContainer>
      <StyledContentContainer>
        <StyledTopRowContainer>
          <StyledLeftSideContainer>
            <BackButton aria-label={t('common.back')} onClick={onBackClick} />
            <StyledApiTitle variant='h1'>{apiHeaderData.title}</StyledApiTitle>
            <StyledIconContainer>
              {apiHeaderData.isPublic ? <PublicIcon /> : <PrivateIcon />}
            </StyledIconContainer>
          </StyledLeftSideContainer>

          <StyledTagsContainer>
            {apiHeaderData.tags.map((tag: string) => (
              <Tag
                key={tag}
                text={tag}
                backgroundColor={theme.palette.tags.lightTagBackground}
                color={theme.palette.tags.lightTagText}
              />
            ))}
          </StyledTagsContainer>
        </StyledTopRowContainer>

        <StyledTabsContainer>
          {tabLabels.map((label) => (
            <StyledTabItem
              key={label}
              onClick={() => onTabChange(label)}
              isActive={activeTab === label}
            >
              <StyledTabLabel variant='h6' isActive={activeTab === label}>
                {t(`apiDetail.tabs.${label.toLowerCase()}`)}
              </StyledTabLabel>
            </StyledTabItem>
          ))}
        </StyledTabsContainer>
      </StyledContentContainer>
    </StyledHeaderContainer>
  );
};

export default ApiHeader;
